export default __webpack_public_path__ + "static/media/img-0283-malta-premium-face.f8f4ae66.png";